import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DataService } from '../services/data.service';
import { ConfigurationService } from '../services/configuration.service';
import { DASHBOARDS } from '../utils/utils';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private dataservice: DataService, private configurationService: ConfigurationService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        //check cookies
        let url = (state.url) ? state.url : DASHBOARDS;
        //console.log(url);

        if (this.configurationService.isLoggedIn()) {
            //console.log("Yes LoggedIn");

            if(this.configurationService.isConfigurationLoaded()) {
                //console.log("Yes ConfigurationLoaded");
                return true;
            } else {
                //console.log("Not ConfigurationLoaded");
                this.router.navigate(['splash', { returnUrl: url }]);
                return false;
            }
        }else{
            //console.log("Not LoggedIn, Navigate to Login");
            // not logged in so redirect to login page with the return url
            this.router.navigate(['/login', { returnUrl: url }]);
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/_guards/auth.guard.ts